import axios, { post } from 'axios';
import cookie from "../func/Cookie";
//import { ver } from '../../public/config.json';
import FormData from 'form-data'

var js_ver = "";
//const server_name = "http://localhost:8080/flange/flange-back/public/main/";
// const server_name = "http://localhost:8080/main/";
// const server_name = "http://rf-id.ir/back-end/public/main/";
const server_name = "https://www.fmc1.ir/back-end/public/main/";
async function readFile(file) {
  const response = await fetch(file)
  const text = await response.text();
  const ver = JSON.parse(text).ver;
  js_ver = ver;
}
async function HandleSubmit(url, infoparams) {
  //console.log("url: ", url);
  const send_obj = {

    'method': 'get',
    'url': server_name + url,
    'params': {
      user: cookie.get("user"),
      token: cookie.get("token"),
      info: infoparams
    },
  }
  await readFile("./config.txt");
  //alert(url+": "+ infoparams);

  try {
    var response = await axios(send_obj);
    console.log("info1: ", response.data);
    if (response.data.status === "OK") {
      //alert(response.data);
      // console.log("ver inja", response.data.ver);
      // console.log("vermooz", js_ver);
      if (response.data.ver == js_ver) {
        return JSON.parse(response.data.info);
      }
      else {
        alert("لطفا جهت به روز رسانی کلید ctrl+f5 را بفشارید");
      }
    }
    else if (response.data.status === "NoAccess") {
      alert("شما مجوز برای این قسمت ندارید");
    }
    else if (response.data.status === "Login") {
      alert("نام کاربری یا رمز عبور اشتباه است");
      cookie.set("user", "");
      cookie.set("name", "");
      cookie.set("token", "");
    }
  }
  catch (e) {
    console.log("e", e);
    alert("مشکل در ارتباط با سرور")
  }
}
async function HandleSubmitSendFile(url, infoparams) {
  var formData = new FormData();
  console.log("infoparams", infoparams);
  // const response = await fetch(file)
  // const text = await response.text();
  formData.append("info", infoparams.sqlfile);
  formData.append("user", cookie.get("user"));
  formData.append("token", cookie.get("token"));
  console.log("formData", formData);
  const send_obj = {
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data'
    },
    url: server_name + url,
    data: formData
  }
  await readFile("./config.txt");
  try {
    console.log("send_obj", send_obj);
    //var response = await axios.post(send_obj.url, send_obj.data);
    var response = await axios(send_obj);
    console.log("info1: ", response.data);
    if (response.data.status === "OK") {
      //alert(response.data);
      if (response.data.ver == js_ver) {
        return JSON.parse(response.data.info);
      }
      else {
        alert("please refresh page");
      }
    }
    else if (response.data.status === "NoAccess") {
      alert("شما مجوز برای این قسمت ندارید");
    }
    else if (response.data.status === "Login") {
      alert("Login");
      cookie.set("user", "");
      cookie.set("name", "");
      cookie.set("token", "");
    }
  }
  catch (e) {
    console.log("e", e);
    alert("Error in. ")
  }
}
function CreateDownloadLink() {
  var user = cookie.get("user");
  var token = cookie.get("token");
  return server_name + "backup/downloadbackup?user=" + user + "&token=" + token + "&info=%7B%7D";
}
export { HandleSubmit, CreateDownloadLink, HandleSubmitSendFile };




// WEBPACK FOOTER //
// ./src/func/HandleSubmit.js